
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"13","height":"12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.695 6.96c-.797 0-1.393-.275-1.789-.827C.516 5.58.32 4.75.32 3.64c0-.771.104-1.412.313-1.922.213-.516.502-.896.867-1.14C1.87.332 2.297.21 2.781.21c.453 0 .834.08 1.14.242.308.162.556.388.743.68.193.286.328.633.406 1.039.084.4.125.844.125 1.328 0 1.14-.216 2.003-.648 2.586-.427.583-1.044.875-1.852.875zM1.477 3.509c0 1.01.104 1.745.312 2.203.208.458.54.687.992.687.427 0 .742-.213.946-.64.208-.427.312-1.11.312-2.047 0-1-.104-1.74-.312-2.219-.204-.479-.521-.719-.954-.719-.328 0-.588.11-.78.329-.188.218-.321.528-.4.93-.077.395-.116.887-.116 1.476zM10.64.336L3.75 11.75H2.602L9.508.336h1.133zm-.227 11.539c-.797 0-1.393-.276-1.789-.828-.39-.552-.586-1.383-.586-2.492 0-.771.104-1.412.313-1.922.213-.516.502-.896.867-1.14.37-.246.797-.368 1.281-.368.453 0 .833.08 1.14.242.308.162.555.388.743.68.193.286.328.633.406 1.039.083.401.125.844.125 1.328 0 1.14-.216 2.003-.648 2.586-.428.583-1.045.875-1.852.875zM9.195 8.422c0 1.01.104 1.745.313 2.203.208.458.539.688.992.688.427 0 .742-.214.945-.641.209-.427.313-1.11.313-2.047 0-1-.104-1.74-.313-2.219-.203-.479-.52-.718-.953-.718-.328 0-.588.109-.781.328-.188.218-.32.528-.399.93-.078.395-.117.887-.117 1.476z","fill":"currentColor"}})])
          )
        }
      }
    